import * as angular from 'angular';
import * as _ from 'lodash';

import { Store, Dispatch, Dispatcher } from '../Store';
import * as Actions from './alarmCategories.actions';
import { Alarm } from '../../models';
import { IAlarmService } from '../../services';

export interface IAlarmCategoriesActionsService {
    getAll(): Dispatcher<string[]>;
    getAll(force: boolean): Dispatcher<string[]>;
}

export class AlarmCategoriesActionsService implements IAlarmCategoriesActionsService {
    static serviceId = 'alarmCategoriesActionsService';
    static $inject = ['$q', 'alarmService'];

    constructor(
        private _$q: angular.IQService,
        private _alarmService: IAlarmService) {
    }

    getAll();
    getAll(force: boolean);
    getAll(force?: boolean): Dispatcher<string[]> {
        return (dispatch: Dispatch<string[]>, getState: () => Store) => {
            const { alarmCategories } = getState();
            if (force || !alarmCategories.isLoading && !alarmCategories.isLoaded) {
                dispatch(Actions.loadAlarmCategories());
                return this._alarmService
                    .getAll(force)
                    .then(data => {
                        const allAlarmsArray: Alarm[][] = _.values(data);
                        let allAlarms: Alarm[] = [];
                        allAlarmsArray.forEach(alarmArray => {
                            allAlarms = allAlarms.concat(alarmArray);
                        });
                        const results: string[] = [].concat(...allAlarms.map(a => a.categories));
                        dispatch(Actions.loadAlarmCategoriesSuccess(results));
                        return results;
                    })
                    .catch((reason) => {
                        dispatch(Actions.loadAlarmCategoriesError(reason));
                        return reason;
                    });
            } else {
                return this._$q.when(alarmCategories.dictionary);
            }
        };
    }
}